class MobileSwipe extends HTMLElement {
	connectedCallback() {
		this.element = this;
		this.elements = this.querySelectorAll('li');
		this.currentIndex = 0;

		this.element.closest('.product-card')?.style.setProperty('--slide-count', this.elements.length);

		this.observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.currentIndex = entry.target.index;
						this.moveBarTo(this.currentIndex);
						document.dispatchEvent(new CustomEvent('custom:carousel:index', { detail: entry.target.index }));
					}
				});
			},
			{
				threshold: 0.51,
			},
		);

		this.elements.forEach((element, index) => {
			// eslint-disable-next-line no-param-reassign
			element.index = index;
			this.observer.observe(element);
			element.addEventListener('dragstart', e => e.preventDefault());
		});

		this.initTouch();

		this.addEventListener('touchstart', (e) => {
			this.element.querySelectorAll('img[loading]').forEach((el) => el.removeAttribute('loading'));
		});

		this.addEventListener('mouseenter', (e) => {
			this.element.classList.remove('scroll-smooth');
			this.element.querySelectorAll('img[loading]').forEach((el) => el.removeAttribute('loading'));
			const multiplier = this.dataset.hoverOnly ? 1 : 2;

			this.element.scrollLeft = this.element.getBoundingClientRect().width * multiplier;
			requestAnimationFrame(() => {
				this.element.classList.add('scroll-smooth');
			});
		});

		this.addEventListener('mouseleave', (e) => {
			this.element.classList.remove('scroll-smooth');
			this.element.scrollLeft = 0;
			requestAnimationFrame(() => {
				this.element.classList.add('scroll-smooth');
			});
		});
	}

	moveBarTo (index) {
		this.element.closest('.product-card')?.style.setProperty('--current-index', index);
	}

	initTouch() {
		this.elements.forEach((element) => element.classList.add('pointer-events-none', 'select-none'));

		let isDrag = false;
		let startX = 0;
		let startY = 0;
		let timeout;
		const dragStart = (ev) => {
			isDrag = true;
			this.element.classList.add('snap-none');
			if (timeout) clearTimeout(timeout);
			startX = ev.x;
			startY = ev.y;
		};
		const dragEnd = (ev) => {
			if (!isDrag) return;
			isDrag = false;
			timeout = setTimeout(() => {
				this.element.classList.remove('snap-none');
			}, 700);
		};
		const drag = (event) => {
			if (!isDrag) return;
			this.element.scrollLeft -= event.movementX * 1.6;
		};

		const click = function (ev) {
			this.closest('.product-card')?.querySelector('.product-card__heading a')?.click();
		}

		this.element.addEventListener('pointerdown', dragStart);
		this.element.addEventListener('pointerup', dragEnd);
		this.element.addEventListener('pointercancel', dragEnd);
		this.element.addEventListener('pointermove', drag);
		this.element.addEventListener('click', click);
	}
}

customElements.define('mobile-swipe', MobileSwipe);
